import styled from 'styled-components'

export const Container = styled.div`

  > div {
    gap: 20px;
  }

  > button {
    margin-top: 30px;
    width: 100%;
  }
`